module.exports = __webpack_public_path__ + "img/Boy_030017.eea4405c.png";